import { Radio } from 'antd';

import YesNoStep from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/YesNoStep';
import { WizardDescription } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardDescription';
import useWizard from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/context/useWizard';

const VARIABLE_WEIGHT_FIELD = 'variableWeight';

const FoodServiceStep = () => {
  const { currentStep, state, actions } = useWizard();

  return (
    <YesNoStep step={currentStep}>
      <div className='wizard-question-row'>
        <WizardDescription>
          {currentStep.variableWeightQuestion}
        </WizardDescription>
        <Radio.Group
          value={state.answers[VARIABLE_WEIGHT_FIELD]}
          onChange={(e) =>
            actions.setAnswer(VARIABLE_WEIGHT_FIELD, e.target.value)
          }
        >
          <Radio value={true}>Yes</Radio>
          <Radio value={false}>No</Radio>
        </Radio.Group>
      </div>
    </YesNoStep>
  );
};

export default FoodServiceStep;
